import React, { ReactNode } from 'react'
import useTranslation from 'next-translate/useTranslation'
import { Stack } from 'rsuite'

import TranslatableText from './ugcTranslate/TranslatableText'
import { IConditionalQuestionsMap, QuestionsConfig } from '../../../utils/types/Review'
import questionsConfigJson from '../../../utils/reviewQuestionConfig.json'

const allQuestions = questionsConfigJson as QuestionsConfig

const ConditionalParagraph = (key: string, value: string, index: number): ReactNode => {
  const { t } = useTranslation('products')

  return (
    <Stack
      key={index}
      spacing={5}
      alignItems="stretch"
      direction="column"
    >
      <strong>{t(key)}</strong>
      <TranslatableText originalText={value} />
    </Stack>
  )
}

const renderQuestionsRecursively = (map: IConditionalQuestionsMap): ReactNode => {
  if (map && Object.keys(map).length) {
    return (
      <Stack
        direction="column"
        spacing={5}
        alignItems="stretch"
      >
        {
        Object.keys(map)
          .filter((key) => allQuestions[key] && allQuestions[key].type !== 'file')
          .map((key, index) => {
            if (typeof map[key] === 'string') {
              return ConditionalParagraph(key, map[key] as string, index)
            }
            return renderQuestionsRecursively(map[key] as IConditionalQuestionsMap)
          })
        }
      </Stack>
    )
  }

  return null
}

export default renderQuestionsRecursively
